import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { parseCookies } from 'nookies';
import Cookie from 'js-cookie';
import { defineUserCoordinates, rehydrateStore, openModal } from '../redux/actions';
import { axiosInstance, getCanonicalHost } from "../utils";
import { Layout, Header, Promo, WaysToDaycation, HowItWorks, DayAxeMoments, Footer } from "../components";
import { FeaturedHotelPasses, FeaturedHotelsSlider, OurPromotions } from "../containers";

const mapDispatchToProps = dispatch => bindActionCreators({
  handleUserGPSCoords: defineUserCoordinates,
  openLoginModal: openModal,
}, dispatch);

@connect(null, mapDispatchToProps)
class IndexPage extends Component {
  static propTypes = {
    query: PropTypes.instanceOf(Object),
    handleUserGPSCoords: PropTypes.func,
    openLoginModal: PropTypes.func,
    canonicalUrl: PropTypes.string,
  };

  static async getInitialProps(ctx) {
    const { query, req, reduxStore } = ctx;

    if (req) {
      const userPreferences = parseCookies(ctx)['user-preferences'] || '{}';
      const parsedUserPreferences = JSON.parse(userPreferences);
      reduxStore.dispatch(rehydrateStore(parsedUserPreferences));
    }

    const { data: categories } = await axiosInstance
      .get('products/categories');
    const newObject = {
      ...query,
      categories: categories.categories,
    };

    const canonicalUrl = `https://${getCanonicalHost()}`;

    return { query: newObject, canonicalUrl };
  };

  componentDidMount() {
   const { handleUserGPSCoords, openLoginModal } = this.props;
    handleUserGPSCoords();

    if (Cookie.get('withLogin')) {
      Cookie.remove('withLogin');
      openLoginModal('login');
    }
  }

  render() {
    const { query, canonicalUrl } = this.props;
    const { categories } = query;

    return (
      <Layout
        heading="Book pool time, cabana, spa and fitness pass at luxury hotels | Dayaxe.com"
        description="We have 100s of luxury pool, cabana, spa and fitness hotel day passes for as little as $20/guest. Read reviews, compare prices and food & drink discounts. Book your resort pass with two clicks."
        metaKeywords="VIP pass, day pass, day access, hotel pass, pool pass, hotel pool access, hotel gym access, day pass for hotel, hotel day pass, spa pass, Beach Day Pass, Pool and Beach Day Pass, office space at hotel"
        canonical={canonicalUrl}
        url={canonicalUrl}
      >
        <Header />
        <Promo />
        <FeaturedHotelsSlider />
        <WaysToDaycation categories={categories} />
        <FeaturedHotelPasses />
        <HowItWorks />
        <DayAxeMoments />
        <OurPromotions />
        <Footer />
      </Layout>
    );
  }
}

export default IndexPage;
